import React, {FC, ReactElement} from 'react'
import { ReactSVG } from "react-svg";

interface Props {
  text: string
  className?: string
  children?: ReactElement | string
}

const PageNotification: FC<Props> = ({ text, className, children }) => {
  return (
    <div className={`page-notification ${className ?? ''}`.trim()}>
      <div className={'page-notification__inner'}>
        <ReactSVG
          src={'/i/svg/alert-circle.svg'}
          className={'svg-icon'}
          wrapper={'span'}
        />
        {text}
      </div>
      {children}
    </div>
  )
}

export default PageNotification
